import React, {useState} from "react";
// import {useTranslation} from "react-i18next";
import Navbar from "./navbar/navbar";
import {Link} from "react-router-dom";

function Header(props) {
    // const { t, i18n } = useTranslation();

    return (
        <div className="container-fluid p-0">
            <header className="header m-auto= fixed-top= liquid-glass= bg-white= opacity-75= rounded-5=">
                <Navbar />
            </header>
        </div>
    );
}

export default Header;
